import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

const ROUND_OPTIONS = [
    { value: 'round', label: '四捨五入' },
    { value: 'ceil', label: '切り上げ' },
    { value: 'floor', label: '切り捨て' },
];

defineBlock({
    type: 'math_round',
    colour: CATEGORIES.operator.color,
    tooltip: '数値を丸めます',
    movable: true,
    deletable: true,
    inline: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    name: 'ROUND_LABEL',
                    instance: () =>
                        new FieldStyledLabel('ROUND', {
                            fontSize: 12,
                            fontWeight: 'bold',
                        }),
                },
                { type: 'label', text: ' ' },
            ],
        },
        {
            kind: 'value',
            name: 'VALUE',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 0 } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'の小数点以下を' }],
        },
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    name: 'OP',
                    instance: () => new FieldOperatorDropdown(ROUND_OPTIONS),
                },
            ],
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'にした数値 ' }],
        },
    ],
    onInit(this: Blockly.Block) {
        const labelField = this.getField('ROUND_LABEL') as FieldStyledLabel;
        const opField = this.getField('OP') as FieldOperatorDropdown;

        const labelMap: Record<string, string> = {
            round: 'ROUND',
            ceil: 'CEIL',
            floor: 'FLOOR',
        };

        opField?.setOnValueChange((value) => {
            labelField?.setValue(labelMap[value] ?? value);
        });
    },
});
